var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_989_2719)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.66662 3.33334H12.3333C12.4293 3.36702 12.5163 3.42222 12.5877 3.49472C12.6591 3.56722 12.7129 3.6551 12.7451 3.75162C12.7773 3.84815 12.7869 3.95076 12.7733 4.05159C12.7597 4.15242 12.7232 4.2488 12.6666 4.33334L9.33328 8.00001V12.6667L6.66662 10.6667V8.00001L3.33328 4.33334C3.27668 4.2488 3.24017 4.15242 3.22657 4.05159C3.21296 3.95076 3.22262 3.84815 3.25479 3.75162C3.28697 3.6551 3.34081 3.56722 3.41219 3.49472C3.48357 3.42222 3.5706 3.36702 3.66662 3.33334Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_989_2719"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.c6a8c8d7f39582f1942c93ebf0da305a.svg";
export { ForwardRef as ReactComponent };